import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'summury'
})
export class SummuryPipe implements PipeTransform {

  transform(value: string, limit? : any) {
    if(!value){
      return null;
    }
    return value.substring(0,limit)+"...";
  }
}
